import { Data as ArticleData } from '@root/modules/article/types/article';

const updateArticleContent = (_article: ArticleData, articleWithAccess: ArticleData): ArticleData => {
  const article = { ..._article };
  article.settings = { ...article.settings, ...articleWithAccess.settings };
  article.ttsSettings = articleWithAccess.ttsSettings;
  article.content.lead.content = articleWithAccess.content.lead.content;
  article.content.leadElement.content = articleWithAccess.content.leadElement.content;
  article.content.body.content = articleWithAccess.content.body.content;
  article.content.groupedBody = articleWithAccess.content.groupedBody;
  article.content.paywall.access = articleWithAccess.content.paywall.access;

  return article;
};

export const fillArticleData = (
  newArticleData: ArticleData,
  currentArticleData: ArticleData | null,
  context: { articleBaseDataExists: boolean }
): ArticleData => {
  if (!context.articleBaseDataExists || !currentArticleData) {
    return newArticleData;
  }

  return updateArticleContent(currentArticleData, newArticleData);
};
